<div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
  <button nz-button nzType="default" [nzLoading]="isExporting" (click)="exportCsv()">
    <span nz-icon nzType="download"></span>
    <span i18n>Download as CSV</span>
  </button>
</div>
<nz-table #sortFilterTable
          [nzData]="filteredAndSortedBatches"
          [nzVirtualForTrackBy]="trackByIndex"
          [nzBordered]="true"
          [nzVirtualItemSize]="virtualItemSize"
          [nzVirtualMinBufferPx]="virtualItemSize * 10"
          [nzVirtualMaxBufferPx]="virtualItemSize * 10"
          nzFrontPagination="false"
          nzShowPagination="false"
          nzSize="small"
          [nzScroll]="{ y: 'calc(100vh - 200px)', x: 'max-content' }">
  <thead>
    <tr>
      <th nzWidth="80px" nzColumnKey="inspectionSequence" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('inspectionSequence', $event); dispatchQuery()">
        <div i18n>#</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['inspectionSequence']" [nzActive]="isNumericFilterActive('inspectionSequence')" [nzDropdownMenu]="inspectionSequenceFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="120px" nzColumnKey="state" [nzSortFn]="true" [nzFilters]="stateOptions" [nzFilterMultiple]="true"
          (nzSortOrderChange)="onSortChange('state', $event); dispatchQuery()" (nzFilterChange)="onStateFilterChange($event)">
        <div i18n>Status</div>
      </th>
      <th nzWidth="80px" nzColumnKey="scannerId" [nzSortFn]="true" [nzFilters]="scannerIdOptions" [nzFilterMultiple]="true"
          (nzSortOrderChange)="onSortChange('scannerId', $event); dispatchQuery()" (nzFilterChange)="onScannerIdFilterChange($event)">
        <div><span nz-icon nzType="camera"></span></div>
      </th>
      <th nzWidth="150px" nzColumnKey="poName" [nzSortFn]="true" (nzSortOrderChange)="onSortChange('poName', $event); dispatchQuery()">
        <div i18n>PO / Batch</div>
        <input nz-input [(ngModel)]="filters.poName" (ngModelChange)="dispatchQuery()" nzSize="small" style="margin-top: 4px;" />
      </th>
      <th nzWidth="120px" nzColumnKey="colorCode" [nzSortFn]="true" (nzSortOrderChange)="onSortChange('colorCode', $event); dispatchQuery()">
        <div i18n>Color</div>
        <input nz-input [(ngModel)]="filters.colorCode" (ngModelChange)="dispatchQuery()" nzSize="small" style="margin-top: 4px;" />
      </th>
      <th nzWidth="120px" nzColumnKey="baseMaterial" [nzSortFn]="true" [nzFilters]="baseMaterialOptions" [nzFilterMultiple]="true"
          (nzSortOrderChange)="onSortChange('baseMaterial', $event); dispatchQuery()" (nzFilterChange)="onBaseMaterialFilterChange($event)">
        <div i18n>Base</div>
      </th>
      <th nzWidth="120px" nzColumnKey="producingQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('producingQuantity', $event); dispatchQuery()">
        <div i18n>Producing</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['producingQuantity']" [nzActive]="isNumericFilterActive('producingQuantity')" [nzDropdownMenu]="producingQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="120px" nzColumnKey="orderedQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('orderedQuantity', $event); dispatchQuery()">
        <div i18n>Ordered</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['orderedQuantity']" [nzActive]="isNumericFilterActive('orderedQuantity')" [nzDropdownMenu]="orderedQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="120px" nzColumnKey="remainingQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('remainingQuantity', $event); dispatchQuery()">
        <div i18n>Remaining</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['remainingQuantity']" [nzActive]="isNumericFilterActive('remainingQuantity')" [nzDropdownMenu]="remainingQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="140px" nzColumnKey="totalRemainingQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('totalRemainingQuantity', $event); dispatchQuery()">
        <div i18n>Total Remaining</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['totalRemainingQuantity']" [nzActive]="isNumericFilterActive('totalRemainingQuantity')" [nzDropdownMenu]="totalRemainingQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="120px" nzColumnKey="inspectedQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('inspectedQuantity', $event); dispatchQuery()">
        <div i18n>Inspected</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['inspectedQuantity']" [nzActive]="isNumericFilterActive('inspectedQuantity')" [nzDropdownMenu]="inspectedQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="140px" nzColumnKey="totalInspectedQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('totalInspectedQuantity', $event); dispatchQuery()">
        <div i18n>Total Inspected</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['totalInspectedQuantity']" [nzActive]="isNumericFilterActive('totalInspectedQuantity')" [nzDropdownMenu]="totalInspectedQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="100px" nzColumnKey="failedQuantity" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('failedQuantity', $event); dispatchQuery()">
        <div i18n>Failed</div>
        <nz-filter-trigger [(nzVisible)]="numericFilterVisible['failedQuantity']" [nzActive]="isNumericFilterActive('failedQuantity')" [nzDropdownMenu]="failedQuantityFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="100px" nzColumnKey="dEAvg" [nzSortFn]="true" (nzSortOrderChange)="onSortChange('dEAvg', $event); dispatchQuery()">
        <div i18n>dEAvg</div>
        <input nz-input [(ngModel)]="filters.dEAvg" (ngModelChange)="dispatchQuery()" nzSize="small" style="margin-top: 4px;" />
      </th>
      <th nzWidth="100px" nzColumnKey="dEMax" [nzSortFn]="true" (nzSortOrderChange)="onSortChange('dEMax', $event); dispatchQuery()">
        <div i18n>dEMax</div>
        <input nz-input [(ngModel)]="filters.dEMax" (ngModelChange)="dispatchQuery()" nzSize="small" style="margin-top: 4px;" />
      </th>
      <th nzWidth="100px" nzColumnKey="ci" [nzSortFn]="true" (nzSortOrderChange)="onSortChange('ci', $event); dispatchQuery()">
        <div i18n>CI</div>
        <input nz-input [(ngModel)]="filters.ci" (ngModelChange)="dispatchQuery()" nzSize="small" style="margin-top: 4px;" />
      </th>
      <th nzWidth="150px" nzColumnKey="modifiedTime" [nzSortFn]="true" nzCustomFilter (nzSortOrderChange)="onSortChange('modifiedTime', $event); dispatchQuery()">
        <div i18n>Last Used</div>
        <nz-filter-trigger [(nzVisible)]="modifiedTimeFilterVisible" [nzActive]="modifiedTimeFilterActive" [nzDropdownMenu]="modifiedTimeFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
      <th nzWidth="150px" nzColumnKey="startedTime" [nzSortFn]="true" [nzSortOrder]="sortMap['startedTime'] || null" nzCustomFilter (nzSortOrderChange)="onSortChange('startedTime', $event); dispatchQuery()">
        <div i18n>Started</div>
        <nz-filter-trigger [(nzVisible)]="startedTimeFilterVisible" [nzActive]="startedTimeFilterActive" [nzDropdownMenu]="startedTimeFilterMenu">
          <span nz-icon nzType="filter" nzTheme="fill"></span>
        </nz-filter-trigger>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-template nz-virtual-scroll let-batch let-index="index">
      <tr
          [routerLink]="['/pos', batch.id]"
          [style.background-color]="batch.state == PoState.IsInspected || batch.current ? 'lightgreen' : batch.next? 'lightblue': undefined"
          [@highlight]="batch.modifiedTime?.getTime()">
        <td>{{ batch.inspectionSequence }}</td>
        <td>
          <app-batch-status-icon [status]="batch.state"></app-batch-status-icon>
          {{ batch.state | i18nSelect: poStateTranslation }}
        </td>
        <td>{{ batch.scannerId }}</td>
        <td (click)="$event.stopPropagation()"><a [routerLink]="['/pos', batch.id]">{{ batch.poName }}
            /{{ batch.sequenceInPo + 1 }}</a></td>
        <td>
          <div [style.background]="colorPicker(batch.color?.lab)" class="color-div" nz-tooltip [nzTooltipTrigger]="batch.color?.lab?.l>0 ? 'hover' : null"
               [nzTooltipTitle]="colorTooltip2"></div>
          {{ batch.color.code }}

          <ng-template #colorTooltip2>
            <p>{{ toColorTooltip(batch.color, 1) }}</p>
            <p>{{ toColorTooltip(batch.color, 8) }}</p>
            <p>LAB - L: {{ batch.color?.lab.l.toFixed(1) }}, A: {{ batch.color?.lab.a.toFixed(1) }},
              B: {{ batch.color?.lab.b.toFixed(1) }}</p>
          </ng-template>
        </td>
        <td>{{ data[batch.baseMaterialId.toString()] || batch.baseMaterialId }}</td>
        <td>{{ batch.producingQuantity }}</td>
        <td>@if (batch.sequenceInPo>0) {{{ batch.totalProducingQuantity }}/}{{ batch.orderedQuantity }}</td>
        <td>{{ batch.remainingQuantity }}</td>
        <td>@if (batch.sequenceInPo>0) {{{ batch.totalRemainingQuantity }}}</td>
        <td>{{ batch.inspectedQuantity }}</td>
        <td>@if (batch.sequenceInPo>0) {{{ batch.totalInspectedQuantity }}}</td>
        <td>{{ batch.failedQuantity ? batch.failedQuantity : "" }}</td>
        <td>{{ batch.dEAvg ? (batch.dEAvg | number : '1.2-2') : "∅" }}</td>
        <td>{{ batch.dEMax ? (batch.dEMax | number : '1.2-2') : "∅" }}</td>
        <td>{{ batch?.scans[0]?.ci ? (batch.scans[0].ci | number : '1.2-2') : "" }}</td>
        <td>
          {{ batch.modifiedTime | date:'yyyy-MM-dd HH:mm:ss' }}
        </td>
        <td>
          {{ batch.startedTime | date:'yyyy-MM-dd HH:mm:ss' }}
        </td>
      </tr>
    </ng-template>
  </tbody>
</nz-table>

<nz-dropdown-menu #modifiedTimeFilterMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown" style="padding: 8px; display: flex; flex-direction: column; gap: 8px;">
    <nz-range-picker [(ngModel)]="modifiedTimeRange" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss"></nz-range-picker>
    <div style="display: flex; justify-content: space-between; gap: 8px;">
      <button nz-button nzType="link" nzSize="small" (click)="resetModifiedTimeFilter()" i18n>Reset</button>
      <button nz-button nzType="primary" nzSize="small" (click)="applyModifiedTimeFilter()" i18n>Search</button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #startedTimeFilterMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown" style="padding: 8px; display: flex; flex-direction: column; gap: 8px;">
    <nz-range-picker [(ngModel)]="startedTimeRange" nzShowTime nzFormat="yyyy-MM-dd HH:mm:ss"></nz-range-picker>
    <div style="display: flex; justify-content: space-between; gap: 8px;">
      <button nz-button nzType="link" nzSize="small" (click)="resetStartedTimeFilter()" i18n>Reset</button>
      <button nz-button nzType="primary" nzSize="small" (click)="applyStartedTimeFilter()" i18n>Search</button>
    </div>
  </div>
</nz-dropdown-menu>

<!-- Shared operator (=, >, >=, <, <=, between) + value form for every numeric (double/integer)
     column filter — one instance reused per column via ngTemplateOutlet, avoiding 8x duplication
     of the same form markup (only the dropdown-menu/filter-trigger wiring per <th> stays per-column,
     matching the modifiedTime/startedTime pattern above). -->
<ng-template #numericFilterTpl let-key="key">
  <div class="ant-table-filter-dropdown" style="padding: 8px; display: flex; flex-direction: column; gap: 8px; width: 200px;">
    <nz-select [(ngModel)]="numericFilters[key].operator" nzSize="small" style="width: 100%;">
      <nz-option nzLabel="=" nzValue="Equal"></nz-option>
      <nz-option nzLabel=">" nzValue="GreaterThan"></nz-option>
      <nz-option nzLabel=">=" nzValue="GreaterThanOrEqual"></nz-option>
      <nz-option nzLabel="<" nzValue="LessThan"></nz-option>
      <nz-option nzLabel="<=" nzValue="LessThanOrEqual"></nz-option>
      <nz-option i18n-nzLabel nzLabel="Between" nzValue="Between"></nz-option>
    </nz-select>
    <nz-input-number [(ngModel)]="numericFilters[key].value" nzSize="small" style="width: 100%;"></nz-input-number>
    @if (numericFilters[key].operator === 'Between') {
      <nz-input-number [(ngModel)]="numericFilters[key].valueTo" nzSize="small" style="width: 100%;" i18n-nzPlaceHolder nzPlaceHolder="to"></nz-input-number>
    }
    <div style="display: flex; justify-content: space-between; gap: 8px;">
      <button nz-button nzType="link" nzSize="small" (click)="resetNumericFilter(key)" i18n>Reset</button>
      <button nz-button nzType="primary" nzSize="small" (click)="applyNumericFilter(key)" i18n>Search</button>
    </div>
  </div>
</ng-template>

<nz-dropdown-menu #inspectionSequenceFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'inspectionSequence' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #producingQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'producingQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #orderedQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'orderedQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #remainingQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'remainingQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #totalRemainingQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'totalRemainingQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #inspectedQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'inspectedQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #totalInspectedQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'totalInspectedQuantity' }"></ng-container>
</nz-dropdown-menu>
<nz-dropdown-menu #failedQuantityFilterMenu="nzDropdownMenu">
  <ng-container *ngTemplateOutlet="numericFilterTpl; context: { key: 'failedQuantity' }"></ng-container>
</nz-dropdown-menu>
